import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../../services/analyticsService';

const FeedbackThanksPage: React.FC = () => {
  useEffect(() => {
    trackEvent('feedback_thanks_view');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-dark-900 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-dark-800 rounded-2xl p-8 text-center border border-system-blue/20">
        <div className="text-6xl mb-6">🙏</div>
        <h1 className="text-3xl font-bold text-white mb-4 font-rajdhani">Thank You!</h1>
        <p className="text-gray-300 mb-6 leading-relaxed">
          Your feedback is incredibly valuable to us. It helps us understand what works well and how we can make AwakenArc even better for everyone.
        </p>
        <p className="text-gray-400 mb-8 text-sm">
          We've noted your responses and will use them to improve the platform. No more emails will be sent to you.
        </p>

        <div className="space-y-3">
          <Link
            to="/auth"
            className="block w-full bg-gradient-to-r from-system-blue to-accent-gold text-white font-semibold py-3 px-6 rounded-lg hover:from-system-blue/90 hover:to-accent-gold/90 transition-all duration-200 font-rajdhani"
          >
            Try AwakenArc
          </Link>

          <Link
            to="/"
            className="block text-gray-400 hover:text-white transition-colors text-sm"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeedbackThanksPage;
